import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function CTASection({ heading, text, primary, secondary, testId = "cta-section" }) {
  return (
    <section className="bg-pine text-canvas" data-testid={testId}>
      <div className="container-x py-20 sm:py-28">
        <Reveal>
          <h2 className="max-w-3xl text-3xl font-medium leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            {heading}
          </h2>
          {text && <p className="mt-6 max-w-2xl text-lg leading-relaxed text-canvas/80">{text}</p>}
          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4">
            {primary && (
              <Link
                to={primary.to}
                data-testid={primary.testId}
                className="inline-flex items-center gap-2 bg-canvas px-7 py-3.5 text-base font-medium text-pineink transition-colors duration-300 hover:bg-white"
              >
                {primary.label}
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </Link>
            )}
            {secondary && (
              <Link
                to={secondary.to}
                data-testid={secondary.testId}
                className="text-base font-medium text-canvas underline decoration-canvas/40 underline-offset-8 transition-colors duration-300 hover:decoration-canvas"
              >
                {secondary.label}
              </Link>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
